import * as React from "react";

function SvgHeadsUpAi(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 114.5 121"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M56.8 0C56.5.5-.2 121 0 121c.2 0 31.5-4.2 47.5-6.4V97.2H34.1c-.1 0 22.5-53 22.6-53.2.1-.2 21.6 53.2 21.5 53.2H64.5v17.3c14.9 2.1 46.5 6.5 46.7 6.5C111.4 121 57-.5 56.8 0z"
        fill="#fff"
      />
      <linearGradient
        id="HeadsUpAI_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={-197.063}
        y1={61.5}
        x2={514.937}
        y2={61.5}
        gradientTransform="matrix(1 0 0 -1 0 122)"
      >
        <stop offset={0} stopColor="#ee0979" />
        <stop offset={1} stopColor="#ff6a00" />
      </linearGradient>
      <path
        d="M56.8 0C56.5.5-.2 121 0 121c.2 0 31.5-4.2 47.5-6.4V97.2H34.1c-.1 0 22.5-53 22.6-53.2.1-.2 21.6 53.2 21.5 53.2H64.5v17.3c14.9 2.1 46.5 6.5 46.7 6.5C111.4 121 57-.5 56.8 0z"
        fill="url(#HeadsUpAI_svg__a)"
        fillOpacity={0.9}
      />
    </svg>
  );
}

export default React.forwardRef(SvgHeadsUpAi);
